import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';
import {GlobalConstants} from 'src/app/global-constants'

@Component({
  selector: 'app-generate-suspension-notices',
  templateUrl: './generate-suspension-notices.component.html',
  styleUrls: ['./generate-suspension-notices.component.scss']
})
export class GenerateSuspensionNoticesComponent implements OnInit {


  constructor(
    private keycloakService: KeycloakService,
    private appConstants : AppConstants
  ) { }

  userInfo: any;
  async ngOnInit() {
    this.isLoading = true
      const user = this.appConstants.userDetails
      this.userInfo = user
      this.sendSuspensionNoticesInfo();
  }
  
  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  suspensionNoticesInfo: any = {}
  sendSuspensionNoticesInfo() {
    let details = {
      sprigEndPoint: this.appConstants.endPoints.sprigEndPoint,
      scheduleApplicationID: GlobalConstants.scheduleApplicationID,
      certificatesEndPoint: this.appConstants.endPoints.certificatesEndPoint,
      deliveryOrganizationEndPoint: this.appConstants.endPoints.deliveryOrganizationEndPoint,
      userInfo: this.userInfo
    }
    this.suspensionNoticesInfo = {...{}, ...details}
      this.getToken();
      setTimeout(() => {
        this.getToken();
      }, 1000);
  }

  isLoading : boolean = false
  loadingEvent(event){
    if(event && event.detail)
     this.isLoading = false
  }

  goToQueue(event){
    // if(event && event.detail)
    // this.router.navigate(['/queued-correspondence']);
  }

}
